import { PricingCardBase } from './PricingCardBase';
import { Button } from '~/components/ui/Button';
import { sendAnalyticsEvent } from '~/lib/analytics.client';
import { ENTERPRISE } from '~/lib/urls';
import { AnalyticsAction, AnalyticsTrackEvent } from '~/types/analytics';

const trackOpenEnterpriseForm = () => {
  sendAnalyticsEvent({
    action: AnalyticsAction.Track,
    payload: {
      event: AnalyticsTrackEvent.EnterpriseContactUsClicked,
    },
    isAnonymous: true,
  });
};

export const EnterpriseCard = () => {
  return (
    <PricingCardBase
      price="Custom"
      title="Enterprise"
      perks={{
        label: 'You get everything in Pro, plus:',
        items: [
          'Advanced security (SSO, audit logs, compliance support)',
          'Granular admin controls & user provisioning',
          'Dedicated account manager & 24/7 priority support',
          'Custom workflows, integrations & SLAs',
          'Scalable for large teams and high-volume usage',
          'Flexible billing & procurement options',
          'Data governance & retention policies',
          'Hands-on onboarding & enterprise training',
        ],
      }}
      messages={[]}
    >
      <div className="flex flex-col gap-4">
        <span className="text-sm">
          Get advanced security, compliance, and 24/7 support. Customized to your team&apos;s exact needs.
        </span>

        <Button variant="secondary" asChild>
          <a href={ENTERPRISE} onClick={trackOpenEnterpriseForm} target="_blank">
            Ask for a quote
          </a>
        </Button>
      </div>
    </PricingCardBase>
  );
};
